(() => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      e.preventDefault();
      document.querySelector(e.target.getAttribute('href')).scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    });
  });

  let lastPos = 0;
  let ticking = false;

  const toggleHeader = newPos => {
    document.body.classList.toggle('is-fixed', newPos >= 300);
  };
  window.addEventListener('scroll', () => {
    lastPos = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        toggleHeader(lastPos);
        ticking = false;
      });
      ticking = true;
    }
  });
})();
